export const taskStateTypeDef = `
  id
  name
  order
`;
